import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Search, Film, Tv, User } from 'lucide-react';
import { cn } from '@/lib/utils';

const BottomNav = () => {
    const location = useLocation();

    const navItems = [
        { icon: Home, label: 'Inicio', path: '/' },
        { icon: Search, label: 'Buscar', path: '/search' },
        { icon: Film, label: 'Películas', path: '/movies' },
        { icon: Tv, label: 'Series', path: '/series' },
        { icon: User, label: 'Perfil', path: '/favorites' }, // Mapping profile/favorites here
    ];

    return (
        <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden pb-safe">
            <div className="bg-[#0f1014]/95 backdrop-blur-xl border-t border-white/5 px-2 pb-5 pt-3">
                <div className="flex justify-around items-center">
                    {navItems.map((item) => {
                        const Icon = item.icon;
                        const isActive = location.pathname === item.path;

                        return (
                            <Link
                                key={item.path}
                                to={item.path}
                                className={cn(
                                    "flex flex-col items-center gap-1 transition-colors duration-200",
                                    isActive ? "text-white" : "text-gray-500 hover:text-gray-300"
                                )}
                            >
                                <Icon
                                    className={cn("w-6 h-6", isActive && "fill-current")}
                                    strokeWidth={isActive ? 2.5 : 2}
                                />
                                <span className="text-[10px] font-medium tracking-wide">
                                    {item.label}
                                </span>
                            </Link>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default BottomNav;
